/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerCancelMutationResponse, IncidentInvestigationControllerCancelPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerCancel";

function getIncidentInvestigationControllerCancelUrl(id: IncidentInvestigationControllerCancelPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/incident-agent/investigations/${id}/cancel` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/cancel}
 */
export async function incidentInvestigationControllerCancel(id: IncidentInvestigationControllerCancelPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerCancelMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentInvestigationControllerCancelUrl(id).url.toString(), ... requestConfig })  
  return res.data
}